import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scanningConfig } from '../Config';

/**
 * RouteLogger logs route changes (pathname + search) to the console
 * whenever the location changes, if environment variable `VITE_DEBUG` is true.
 *
 * Useful for debugging routing behavior in development or during testing.
 */
export const RouteLogger = () => {
    const location = useLocation();

    useEffect(() => {
        if (scanningConfig.isDebugMode) {
            console.debug('[DEBUG] - Route changed to:', location.pathname + location.search);
        }
    }, [location]);

    return null;
};
